'use client';

import { __spreadArray } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { Container, BenefitCard } from './MultiTagSelect.css.js';
import { listBenefits } from './constant.js';
import { t } from './helper.js';

var MultiTagSelect = function (_a) {
    var _b = _a.numOfColumns, numOfColumns = _b === void 0 ? 3 : _b, _c = _a.langCode, langCode = _c === void 0 ? 'vi' : _c, _d = _a.values, values = _d === void 0 ? [] : _d, onChange = _a.onChange, _e = _a.maxSelect, maxSelect = _e === void 0 ? 0 : _e, _f = _a.readonly, readonly = _f === void 0 ? false : _f, customTag = _a.customTag;
    var _g = useState(values), benefits = _g[0], setBenefit = _g[1];
    var handleChange = function (value) {
        if (readonly)
            return;
        var cpBenefits = __spreadArray([], benefits, true);
        if (cpBenefits.includes(value)) {
            var result = cpBenefits.filter(function (benefit) { return benefit !== value; });
            setBenefit(result);
            onChange(result);
            return;
        }
        if (maxSelect && cpBenefits.length >= maxSelect)
            return;
        cpBenefits.push(value);
        setBenefit(cpBenefits);
        onChange(cpBenefits);
    };
    useEffect(function () {
        setBenefit(values);
    }, [values]);
    return (React__default.createElement(Container, { columns: String(numOfColumns), readonly: readonly }, listBenefits.map(function (_a) {
        var id = _a.id, icon = _a.icon, iconActive = _a.iconActive, name = _a.name;
        var isActive = benefits.includes(id);
        return (customTag || (React__default.createElement(BenefitCard, { key: name, isActive: isActive, onClick: function () { return handleChange(id); } },
            isActive ? iconActive() : icon(),
            React__default.createElement("p", null, t(name, langCode)))));
    })));
};

export { MultiTagSelect as default };
//# sourceMappingURL=index.js.map
